import Rest from '../../Server/Rest';
import config from '../../settings/config';
import _ from 'underscore';
import RequisitionModel from '../../models/RequisitionModel';

// Consulta solicitudes con paginación y filtros
export const fetchSolicitudes = async ({
  limit,
  skip,
  where,
  order,
  include,
}) => {
  const params = new URLSearchParams({
    limit,
    skip,
    where: JSON.stringify(where),
    count: 1,
    order,
    include,
  });
  const res = await Rest.peticion(
    `${config.api_url}/classes/Solicitudes?${params.toString()}`,
    { method: 'GET' }
  );
  return res.json();
};

// Consulta para obtener totales de grandes lotes
export const fetchBigLotTotals = async ({ where, order, include, setPay }) => {
  let requisitions = [];
  // let totalPaid = 0.0;
  const query = async (skip = 0) => {
    const params = new URLSearchParams({
      limit: 1000,
      skip,
      where: JSON.stringify(where),
      count: 1,
      order,
      include,
      keys: 'montos,Pagos,PagosRealizados,montos.monto_autorizado,prestamo_personalizado_interes,prestamo_personalizado_cantidad_pagos,prestamo_personalizado_periodicidad,prestamo_personalizado_cantidad_pagos,factor_cobro,prestamo_personalizado,cantidad_pagos_semanales,prestamo_personalizado_cantidad_pagos',
    });
    const res = await Rest.peticion(
      `${config.api_url}/classes/Solicitudes?${params.toString()}`,
      { method: 'GET' }
    );
    const data = await res.json();
    requisitions = requisitions.concat(data.results);
    if (data.count === requisitions.length) {
      let montos = _.pluck(_.clone(requisitions), 'montos');
      montos = _.flatten(montos);
      const total_desembolsos = _.reduce(
        montos,
        (memo, item) => memo + item.monto_autorizado,
        0
      );
      let total_montopagos = 0;
      _.each(requisitions, (item) => {
        total_montopagos += setPay(item);
      });
      // Aquí deberías llamar a fetchPagosRealizados si necesitas totalPaid
      let balanceDue_total = 0;
      _.each(requisitions, (item) => {
        balanceDue_total += RequisitionModel.balanceDue(item, setPay(item));
      });
      return {
        total_desembolsos,
        total_montopagos,
        totalPaid: 0, // Si necesitas el total pagado, llama a fetchPagosRealizados aparte
        balanceDue_total,
      };
    } else {
      return query(requisitions.length);
    }
  };
  return query(0);
};
